import classNames from "classnames";
import { Slide, ToastContainer } from "react-toastify";
import { useEnvironment } from "../../customHooks/useEnvironment";
import { useWindowDimensions } from "../../customHooks/useWindowDimensions";
import { getToastColor } from "./nofitication";

export const Toast = () => {
  const { environment } = useEnvironment();

  const { width } = useWindowDimensions();

  return (
    <ToastContainer
      className={classNames(
        "!w-full md:!max-w-[360px] md:!p-0 flex flex-col gap-2"
      )}
      toastClassName={(context) =>
        classNames(
          `
        !flex !flex-row !gap-2 w-full max-md:max-w-[90%]
        p-[16px] !p-[16px] rounded-full md:rounded-[8px] max-md:font-medium
        border !min-h-[60px] ${getToastColor(context?.type ?? "default")}
        transition-all md:first:mt-1
        `,
          {
            "max-md:first:mt-[calc(44px+16px)] ": environment === "mobile",
            "max-md:first:mt-4 ": environment !== "mobile",
          }
        )
      }
      closeButton={width >= 768 ? true : false}
      position={width >= 768 ? "top-right" : "top-center"}
      pauseOnHover={width >= 768 ? true : false}
      transition={Slide}
      icon={false}
      autoClose={2000}
      hideProgressBar={true}
      closeOnClick={true}
      draggable={false}
      rtl
    />
  );
};
